import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_generic_doc_approval_hdr_RowClass} from '../../../dbschema';

export class GenericDocApprovalHeaderContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_approval_hdr: bl_fi_generic_doc_approval_hdr_RowClass = new bl_fi_generic_doc_approval_hdr_RowClass();
}
